import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material';
@Component({
  selector: 'app-tagalert',
  templateUrl: './tagalert.component.html',
  styleUrls: ['./tagalert.component.css']
})
export class TagalertComponent implements OnInit {

  constructor(public DialogRef: MatDialogRef<TagalertComponent>) { }

  ngOnInit() {
  }
  closeDialog() {
    const result = 1;
    this.DialogRef.close(result);
  }
}
